import Overlay from "./overlay.js";
export default function SettingsBtn({ settingsBtn, settingsOverlay }) {
    let initialized = false;
    return Object.freeze({
        init
    });
    function init() {
        if (!settingsBtn || !settingsOverlay)
            return;
        if (initialized)
            return;
        const SettingsOverlay = new Overlay(settingsOverlay);
        settingsBtn.addEventListener('click', () => {
            SettingsOverlay.show();
        });
        initialized = true;
    }
}
